import { SITE_BRAND_DISPLAY_NAME } from "@/config/siteBrand";

export default function Footer({ t, lang = "ro", onCookieSettings }) {
  const currentYear = new Date().getFullYear();
  const copyrightText = (t.footer.copyright || "").replace(
    /2014[–-]\d{4}/,
    `2014–${currentYear}`
  );
  const termsHref =
    lang === "ro" ? "/termeni-si-conditii" : `/termeni-si-conditii?lang=${encodeURIComponent(lang)}`;

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0b1220] border-t border-[#0b378c] text-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <img
              src="/resources/logo-selena-white.svg"
              alt={SITE_BRAND_DISPLAY_NAME}
              className="h-16 sm:h-[72px] w-auto max-w-[min(100%,320px)] object-contain object-left opacity-[0.9] drop-shadow-[0_0_1px_rgba(255,255,255,0.18)]"
            />
            <p className="mt-5 text-sm text-slate-400 max-w-sm leading-relaxed">
              {t.footer.tagline}
            </p>
            <div className="mt-6">
              <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#e3191b] mb-3">
                Social
              </div>
              <a
                data-testid="footer-facebook"
                href="https://www.facebook.com/selenaservice"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-start gap-2 w-full max-w-[280px] rounded-md border border-[#1877f2] bg-[#1877f2] hover:bg-[#1665d8] text-white shadow-[0_0_18px_rgba(24,119,242,0.35)] transition-colors px-4 py-2.5 font-mono text-[10px] uppercase tracking-[0.2em]"
              >
                <svg
                  aria-hidden="true"
                  viewBox="0 0 24 24"
                  className="h-4 w-4 flex-shrink-0 fill-current"
                >
                  <path d="M13.5 21v-8h2.7l.4-3h-3.1V8.1c0-.9.3-1.5 1.6-1.5h1.7V3.9c-.3 0-1.3-.1-2.5-.1-2.5 0-4.2 1.5-4.2 4.3V10H8v3h2.6v8h2.9z" />
                </svg>
                Facebook Selena Service
              </a>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#e3191b] mb-4">
              {t.contact.addressLabel}
            </div>
            <div className="text-sm text-slate-200 leading-relaxed">
              {t.contact.address}
            </div>
            <div className="mt-3 font-mono text-xs text-slate-400">
              {t.contact.hours}
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#e3191b] mb-4">
              Legal — Protecția consumatorului
            </div>
            <div className="flex flex-col gap-3">
              <a
                data-testid="footer-anpc"
                href="https://anpc.ro/ce-este-sal/"
                target="_blank"
                rel="noopener noreferrer"
                title={t.footer.anpc}
                className="block hover:opacity-90 transition-opacity"
              >
                <img
                  src="/resources/anpc-sal-banner.png"
                  alt="ANPC — Soluționarea Alternativă a Litigiilor"
                  className="w-full max-w-[280px] h-auto block"
                />
              </a>
              <a
                data-testid="footer-sol"
                href="https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=RO"
                target="_blank"
                rel="noopener noreferrer"
                title={t.footer.sol}
                className="block hover:opacity-90 transition-opacity"
              >
                <img
                  src="/resources/sol-odr-banner.png"
                  alt="SOL — Soluționare Online a Litigiilor"
                  className="w-full max-w-[280px] h-auto block"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500">
            {copyrightText}
          </div>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 justify-end sm:justify-end">
            <a
              data-testid="footer-terms"
              href={termsHref}
              className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400 hover:text-white transition-colors"
            >
              {t.footer.terms}
            </a>
            <button
              data-testid="footer-cookie-settings"
              onClick={onCookieSettings}
              className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-400 hover:text-white transition-colors"
            >
              {t.footer.cookieSettings}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}
